import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { CurrencyAmountDisplay } from 'src/app/shared/utils/currency/currency-format';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { EventName } from 'src/app/core/services/analytics/event-names';
import { NavTab } from 'src/app/core/services/theme/theme-config';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { GameId } from 'src/app/shared/models/game/game-id';
import { TabBarComponent } from '../../../../ui/tabs/tab-bar/tab-bar.component';
import { GameTitleComponent } from '../../../../ui/game-identity/game-title/game-title.component';
import { GameIconComponent } from '../../../../ui/game-identity/game-icon/game-icon.component';
import { NavButtonComponent } from '../../../../ui/buttons/nav-button/nav-button.component';
import { BalancePillComponent } from '../../../../ui/pills/balance-pill/balance-pill.component';

export interface TabOption {
  key: string;
  label: string;
  id: string;
}

@Component({
  selector: 'app-navbar-view',
  templateUrl: './navbar-view.component.html',
  styleUrls: ['./navbar-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NavButtonComponent,
    GameIconComponent,
    GameTitleComponent,
    BalancePillComponent,
    TabBarComponent,
  ],
})
export class NavbarViewComponent {
  readonly gameName = input.required<string>();
  readonly gameId = input.required<GameId>();
  readonly tabs = input<TabOption[]>();
  readonly balance = input<CurrencyAmountDisplay>();
  readonly selectedTabIndex = input(0);
  readonly displayedPendingCount = input<number | null>(null);
  readonly displayedShowDot = input(false);
  readonly showBalance = input(false);

  readonly closeClickedEvent = output<void>();
  readonly tabSelectedEvent = output<string>();

  themeService = inject(ThemeService);
  private analyticsService = inject(AnalyticsService);

  get resultsTabId(): string | null {
    return this.tabs()?.find((tab) => tab.key === NavTab.results)?.id ?? null;
  }

  onCloseClicked() {
    this.closeClickedEvent.emit();
  }

  onTabSelected(event: string) {
    this.tabSelectedEvent.emit(event);
  }

  onBalanceClicked(): void {
    this.analyticsService.log(EventName.NavBarBalancePillClicked);
  }

  onGameIconClicked(): void {
    this.analyticsService.log(EventName.NavBarGameIconClicked);
  }

  onGameTitleClicked(): void {
    this.analyticsService.log(EventName.NavBarGameTitleClicked);
  }
}
